import { Outlet } from 'react-router-dom';
import SettingsSidebar from './SettingsSidebar';

/**
 * SettingsLayout — Replaces the main CRM layout when the user enters settings.
 * Has its own left sidebar (SettingsSidebar) with settings-specific tabs,
 * and renders the active settings page via <Outlet />.
 */
export default function SettingsLayout() {
  return (
    <div className="h-screen flex bg-theme-primary overflow-hidden transition-colors duration-300">
      {/* Settings Sidebar (desktop only) */}
      <div className="hidden lg:block">
        <SettingsSidebar />
      </div>

      {/* Main Content */}
      <main className="flex-1 flex flex-col min-w-0">
        {/* Mobile header for settings */}
        <div className="lg:hidden flex items-center h-14 px-4 bg-theme-secondary border-b border-theme-primary">
          <a
            href="/dashboard"
            className="flex items-center gap-2 text-theme-secondary hover:text-theme-primary transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span className="font-medium text-sm">Back</span>
          </a>
          <h1 className="flex-1 text-center font-semibold text-theme-primary">Settings</h1>
          <div className="w-16" /> {/* spacer for centering */}
        </div>

        <div className="flex-1 overflow-auto">
          <div className="min-h-full p-4 lg:p-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
